import { jsx as i } from "react/jsx-runtime";
import { idsLogger as c, propagateTestid as p } from "../../../utils/helpers.js";
import { LoggerLevels as g } from "../../../utils/enums.js";
import { IressMenuHeading as I } from "../MenuHeading/MenuHeading.js";
import { z as y } from "../../../ToasterProvider-Bw9KrSYf.js";
const L = (e) => (c(
  "IressMenu: mapMenuItems has been deprecated and will be removed in a future version of IDS, please map and render the items array directly in your application instead",
  g.Warn
), e != null && e.length ? e.map(
  ({
    label: r,
    href: m,
    onClick: d,
    divider: t,
    testId: n,
    headingLevel: o,
    selected: u,
    value: a,
    key: f
  }, l) => {
    const s = f ?? String(a || l);
    return o ? /* @__PURE__ */ i(
      I,
      {
        level: o,
        divider: t,
        "data-testid": p(n, "iress-text"),
        children: r
      },
      s
    ) : /* @__PURE__ */ i(
      y,
      {
        onClick: d,
        divider: t,
        selected: u,
        "data-testid": p(n, "iress-button"),
        value: a,
        href: m,
        children: r
      },
      s
    );
  }
) : null);
export {
  L as mapMenuItems
};
